import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { sortValueLabel, useConsultations, useConsultees } from 'api';
import { consultationIdsToAssignState } from 'store';
import { ValueLabelResponse } from 'types';

export type useAssignModalConsulteesReturn = {
  consultees: ValueLabelResponse[];
  consultationIdsToAssign: number[];
};

export const useAssignModalConsultees = (): useAssignModalConsulteesReturn => {
  const { t } = useTranslation('assign_modal');

  const consultationIdsToAssign = useRecoilValue(consultationIdsToAssignState);

  const { data: consultationData } = useConsultations();
  const { data: consulteeData } = useConsultees();

  const consulteeList = consulteeData?.consultees;
  if (!consulteeList) {
    return { consultees: [], consultationIdsToAssign };
  }

  const selectedConsulteeIds = consultationData?.consultations?.items
    ?.filter((consultation) => consultationIdsToAssign.includes(consultation.id))
    .map((consultation) => consultation.assigneeId);

  const selectedConsultees = consulteeList
    .filter((consultee) => selectedConsulteeIds?.includes(consultee.value))
    .sort(sortValueLabel)
    .map((consultee) => ({
      value: consultee.value,
      label: `${consultee.label} (${t('assigned_suffix', 'Assigned')})`,
      disabled: true,
    }));

  const otherConsultees = consulteeList
    .filter((consultee) => !selectedConsulteeIds?.includes(consultee.value))
    .sort(sortValueLabel);

  return {
    consultees: [...selectedConsultees, ...otherConsultees],
    consultationIdsToAssign,
  };
};
